import {apiClient} from '@/shared/services/apiClient';

export interface BiometricEntry {
    id: number;
    user_id: number;
    organization_id: number | null;
    measurement: string;
    value: string;
    units: string | null;
    loinc: string | null;
    recorded_on: string;
    source: string;
    validated: boolean;
    source_ref_id: number | null;
    created_at: string;
}

export interface LatestBiometric {
    measurement: string;
    value: string;
    units: string | null;
    loinc: string | null;
    recorded_on: string;
    source: string;
    validated: boolean;
}

export const BiometricsService = {
    async getAll(): Promise<Record<string, BiometricEntry[]>> {
        const resp = await apiClient.get<{biometrics: Record<string, BiometricEntry[]>}>('/api/user/biometrics');
        return resp.biometrics;
    },

    async getLatest(): Promise<Record<string, LatestBiometric>> {
        const resp = await apiClient.get<{latest: Record<string, LatestBiometric>}>('/api/user/biometrics/latest');
        return resp.latest;
    },

    async add(data: {measurement: string; value: string; units?: string; recorded_on: string}): Promise<BiometricEntry> {
        const resp = await apiClient.post<{biometric: BiometricEntry}>('/api/user/biometrics', data);
        return resp.biometric;
    },

    async update(id: number, data: {value?: string; units?: string; recorded_on?: string}): Promise<BiometricEntry> {
        const resp = await apiClient.put<{biometric: BiometricEntry}>(`/api/user/biometrics/${id}`, data);
        return resp.biometric;
    },

    async remove(id: number): Promise<void> {
        await apiClient.delete(`/api/user/biometrics/${id}`);
    },
};
